module.exports = __webpack_public_path__ + "static/media/ic-comment.d3a7e6be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-comment.svg
// module id = 614
// module chunks = 14